import { INITIAL_DATA_SELECTOR_DATA } from '@atoms/dataSelectors/dataSelector/dataSelector.data';

import type { CheckBoxData } from '@stratumn/studio-shared';

export const initialCheckBoxData: CheckBoxData = {
  title: 'Default CheckBox Title',
  required: true,
  checkboxType: 'checkbox',
  ...INITIAL_DATA_SELECTOR_DATA
};
